import React, { useEffect } from 'react'
import HomeContent from '../components/homeContent'
import Reputation from '../components/reputation'
import About from '../components/about'
import Clients from '../components/clients'
import Consultation from '../components/cunsoltation'
import ConnectUs from '../components/connectUs'
import Experience from '../components/experiance'
// import Services from '../components/services'
import HomeProjects from '../components/homeProjects'
import Brands from '../components/brands'
import Brochure from '../components/Brochure'
import NewServices from '../components/newservises'
import Testimonials from '../components/testimonials'

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <HomeContent />
      <Reputation />
      <About />
      <Experience />
      <Testimonials />
      <HomeProjects />
      <Brochure />
      {/* <Services /> */}
      <NewServices />
      <Brands />
      <Clients />
      <Consultation />
      <ConnectUs />
    </>
  )
}
